import React from 'react';
import server from '../../server';

class PatientCard extends React.Component{
    checkStatus = () =>{
        let status = 1;
        this.props.data.appointments.forEach((app) =>{
            if(app.fisioterapistOpinion != 0)
                status = 1;
            else
                status = 0;
        });

        return status;
    }

    render(){
        const status = this.checkStatus();
        const color = status == 0 ? "yellow" : "green";
        const statusText = status == 0 ? "Em Tratamento" : "Alta";
        return(
            <div onClick={() => this.props.onClick()} class="bdrs-2 bd m-10 card  cur-p modal-toogle">
                <div class="client-image">
                    <img class="w-100p bdrsT" src={server.imagePath + "/profile/" + this.props.data.profilePicture} alt=""/>
                    <span class={"badge pos-a b-0 mB-5 badge-pill bgc-" + color + "-50 c-" + color + "-700 fsz-xs"}>{statusText}</span>
                </div>
                <div class="client-info p-10">
                    <h5 class="c-client-default">
                        <b>{this.props.data.name}</b>
                        <br/>
                        <span class="c-grey-900 fsz-xs">{this.props.data.cpf}</span>
                    </h5>
                </div>
            </div>
        )
    }
}

export default PatientCard;


// WEBPACK FOOTER //
// ./src/pages/patients/PatientCard.js